import React from "react";
import { useInView } from "react-intersection-observer";
import styles from "./AboutMain.module.css";
import massageChairImage from "../../Components/Assets/product_removebg/falcon_s_thumb_1000_half_removebg.png";
import carna from "../../Components/Assets/aboutImg/carna_thumb_1000_bg.jpg";
import quantum from "../../Components/Assets/aboutImg/quantum_thumb.jpg";

const BrandStory = () => {
  const [ref1, inView1] = useInView({ triggerOnce: true });
  const [ref2, inView2] = useInView({ triggerOnce: true });
  const [ref3, inView3] = useInView({ triggerOnce: true });
  const [ref4, inView4] = useInView({ triggerOnce: true });
  const [ref5, inView5] = useInView({ triggerOnce: true });
  const [ref6, inView6] = useInView({ triggerOnce: true });

  return (
    <div className={styles["brand-introduce-container"]}>
      {/* Brand Story Section Intro */}
      <div
        ref={ref1}
        className={`${styles["brand-story-section"]} ${
          inView1 ? styles["animate-bottom"] : ""
        }`}
      >
        <h2 className={styles["section-title"]}>
          Taking on challenges that have never been seen before.
        </h2>
        <p className={styles["section-content"]}>
          BODYFRIEND has made extraordinary attempts to introduce new products
          without taking easy and apparent paths. Having established the first
          medical R&D center, launched the first natural latex bed brand and the
          first self-replaceable direct water purifier, and developed the first
          brain and metal massage features as well as the first juvenile massage
          chair, the Company has pioneered new horizons, although rough.
        </p>
        <p className={styles["section-content"]}>
          In order to enter the global market, the Company recently collaborated
          with world-class brands, such as Lamborghini and Marvel, to introduce
          collaborative products. This was the result of the Company’s
          challenges to create the best products, or rather the best works, that
          have never existed in the world.
        </p>
      </div>

      {/* Bodyfriend Introduction Section */}
      <div className={styles["bodyfriend-intro-section"]}>
        <div
          ref={ref2}
          className={`${styles["intro-text"]} ${
            inView2 ? styles["animate-bottom"] : ""
          }`}
        >
          <h3>No. 1 Brand in the Health Care Market</h3>
          <h2>Bodyfriend</h2>
          <p className={styles["content"]}>
            With overwhelming quality and differentiated design, BODYFRIEND is
            leading the healthcare market. With explosive growth, BODYFRIEND
            consistently occupies more than 50% of Korea's domestic massage
            chair market every year. Beyond its top position in the Korean
            market, the Company has become the leader in the global market.
          </p>
          <h2>BODYFRIEND, Your Friend Designing Your Health</h2>
          <p className={styles["content"]}>
            From massage chairs to 100% natural latex mattresses made in Italy
            and direct water purifiers, BODYFRIEND strives to design health in
            the environment closest to you.
          </p>
        </div>
        <div
          ref={ref3}
          className={`${styles["intro-image"]} ${
            inView3 ? styles["animate-right"] : ""
          }`}
        >
          <img src={massageChairImage} alt="Massage Chair" />
        </div>
      </div>

      {/* Brand Story Section 1 */}
      <div
        ref={ref4}
        className={`${styles["brand-story-section"]} ${
          inView4 ? styles["animate-bottom"] : ""
        }`}
      >
        <h2>Massage Chairs Made by 'Doctors'</h2>
        <p className={styles["content"]}>
          BODYFRIEND's medical R&D center, the only one in the industry, is
          staffed with highly qualified doctors who specialize in orthopedics,
          neurosurgery, internal medicine, psychiatry, otolaryngology, and
          dentistry as well as excellent experts such as brain engineers,
          physical therapists, and music therapists, conducting research and
          development.
          <br></br>
          <br></br>
          Recognizing that a massage chair is a platform that can quickly and
          comfortably fit the entire body at home, they have been conducting R&D
          and technological innovation to create ‘medical chairs and even
          further healthcare robots' by converging the massage technologies that
          have not been in the world with technologies such as IoT and AI.
        </p>
      </div>

      {/* Image Section 1 */}
      <div className={styles["image-section"]}>
        <img src={carna} alt="Massage Chair" />
      </div>

      {/* Brand Story Section 2 */}
      <div
        ref={ref5}
        className={`${styles["brand-story-section"]} ${
          inView5 ? styles["animate-bottom"] : ""
        }`}
      >
        <h2>
          Overtaking the Leading Country and Rising to the Top of the World
        </h2>
        <p className={styles["content"]}>
          The first country where the massage chair market was open was Japan.
          Japanese massage chairs, more like silver products, were slow in
          technical development and had a clunky black-oriented design.
          BODYFRIEND witnessed an opportunity.
          <br></br>
          <br></br>
          Combining the capabilities of its convergence R&D organizations, such
          as the technology lab, design lab, and medical R&D center, BODYFRIEND
          set out on a different path with new technologies and unique designs.
          <br></br>
          <br></br>
          In just 10 years since its establishment, the Company rose to No. 1 in
          the world. (The result of the market research conducted in 2017 by
          Frost & Sullivan, a global market survey research firm)
        </p>
      </div>

      {/* Image Section 2 */}
      <div className={styles["image-section"]}>
        <img src={quantum} alt="Massage Chair" />
      </div>

      {/* Brand Story Section 3 */}
      <div
        ref={ref6}
        className={`${styles["brand-story-section"]} ${
          inView6 ? styles["animate-bottom"] : ""
        }`}
      >
        <h2>Now, Healthcare Robots!</h2>
        <p className={styles["content"]}>
          Already beyond simple massage functions, BODYFRIEND is introducing
          'massage chairs' with medical technologies.
          <br></br>
          <br></br>A massage chair monitors your health condition with biometric
          data at home every day, customers' indicators are accumulated as big
          data through IoT and sensors of massage chairs, and a healthcare robot
          cares for your health based on the AI disease prediction algorithm.
          This is the appearance of BODYFRIEND, of which the medical R&D center
          will present in the near future.
        </p>
      </div>
    </div>
  );
};

export default BrandStory;
